<template>
    <DCard
        padding
    >
        <DTable
            :items="taxRules"
            :fields="getFields"
            hover
            sorter
        >
            <template #country_name="{item}">
                <td>
                    {{ item.country_code ? item.country_name : '-' }}
                </td>
            </template>
            <template #tax_rate="{item}">
                <td>{{ item.tax_rate }}%</td>
            </template>
            <template #tax_rate_with_vat="{item}">
                <td>{{ item.tax_rate_with_vat }}%</td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.id}`"
                            mini
                            icon="pencil"
                            @click="$inertia.get(editTaxRuleLink(item.id))"
                        />
                        <DButton
                            :id="`btn-delete-${item.id}`"
                            mini
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="isInLoadingState"
                            @click="deleteTaxRule(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.tax_rules.index.add_rule_button')"
                @click="$inertia.get($route('settings.tax-rules.create'))"
            />
        </DFabs>

        <DModal
            v-model:show="showConfirmationModal"
            :title="__('settings.tax_rules.index.delete_confirm_modal.title')"
            :message="__('settings.tax_rules.index.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </DCard>
</template>

<script>
export default {
    name: 'TaxRuleIndex',
    props: {
        taxRules: {
            type: Array,
            default: () => { return [] }
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    data () {
        return {
            showConfirmationModal: false,
            deleteCallBack: () => { return {} }
        }
    },
    computed: {
        getFields () {
            if (this.isFinanceSystemNetsuite === true) {
                return [
                    { key: 'id', label: this.__('settings.tax_rules.index.table.headers.id') },
                    { key: 'country_name', label: this.__('settings.tax_rules.index.table.headers.country_name') },
                    { key: 'tax_rate', label: this.__('settings.tax_rules.index.table.headers.tax_rate') },
                    { key: 'tax_key', label: this.__('settings.tax_rules.index.table.headers.tax_key') },
                    { key: 'tax_rate_with_vat', label: this.__('settings.tax_rules.index.table.headers.tax_rate_with_vat') },
                    { key: 'tax_key_with_vat', label: this.__('settings.tax_rules.index.table.headers.tax_key_with_vat') },
                    { key: 'actions', label: '', sorter: false, filter: false }
                ]
            }

            return [
                { key: 'id', label: this.__('settings.tax_rules.index.table.headers.id') },
                { key: 'country_name', label: this.__('settings.tax_rules.index.table.headers.country_name') },
                { key: 'tax_rate', label: this.__('settings.tax_rules.index.table.headers.tax_rate') },
                { key: 'tax_key', label: this.__('settings.tax_rules.index.table.headers.tax_key') },
                { key: 'revenue_account', label: this.__('settings.tax_rules.index.table.headers.revenue_account') },
                { key: 'tax_rate_with_vat', label: this.__('settings.tax_rules.index.table.headers.tax_rate_with_vat') },
                { key: 'tax_key_with_vat', label: this.__('settings.tax_rules.index.table.headers.tax_key_with_vat') },
                { key: 'revenue_account_with_vat', label: this.__('settings.tax_rules.index.table.headers.revenue_account_with_vat') },
                { key: 'actions', label: '', sorter: false, filter: false }
            ]
        }
    },
    methods: {
        editTaxRuleLink (id) {
            return this.$route('settings.tax-rules.edit', { tax_rule: id })
        },
        deleteTaxRule (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(this.$route('settings.tax-rules.destroy', { tax_rule: id }))
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        }
    }
}
</script>
